import { render, staticRenderFns } from "./SanitaerView.vue?vue&type=template&id=5313cbd9&"
import script from "./SanitaerView.vue?vue&type=script&lang=js&"
export * from "./SanitaerView.vue?vue&type=script&lang=js&"
import style0 from "./SanitaerView.vue?vue&type=style&index=0&id=5313cbd9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports